<div class='ContactPrivateNote'>
  <p><b>Private note: </b>{{ privateNote }}</p>
  <p><b>Type: </b>{{ type }}</p>
  <p><b>Note: </b><span [innerHtml]='note'></span></p>
</div>
